import { useGetRecipeLogs } from "@/hooks/useGetRecipeLogs";
import { RecipeLogList } from "./RecipeLogList";
import { RecipeLogError } from "./RecipeLogError";

interface RecipeLogProps {
    readonly recipeId: number;
}

/**
 * The cook log: a quiet, full-width history of every date this recipe was made,
 * newest first — date on the left, note (if any) on the right. View-only.
 */
export const RecipeLog = ({ recipeId }: RecipeLogProps) => {
    const { data, isLoading, isError } = useGetRecipeLogs(recipeId);
    const logs = data ?? [];

    return (
        <section aria-label="Cook log" className="mx-auto w-full max-w-2xl px-4 pb-16 sm:pb-24">
            <h2 className="mb-5 text-center font-display text-[12px] uppercase tracking-[0.2em] text-[var(--fg-muted)]">
                Cook Log
            </h2>

            {isError ? (
                <RecipeLogError recovery="Reload the page to try again." />
            ) : logs.length > 0 ? (
                <RecipeLogList logs={logs} />
            ) : isLoading ? null : (
                <div className="text-center">
                    <p className="font-serif text-[15px] text-[var(--fg-2)]">You haven't prepared this recipe yet.</p>
                    <p className="mt-1 font-serif text-[14px] text-[var(--fg-muted)]">
                        Mark it as made to log your first entry.
                    </p>
                </div>
            )}
        </section>
    );
};
